import { callApi } from '../api';
import { call, put, select, take } from 'redux-saga/effects';
import { normalize, schema } from 'normalizr';
import { updateClusters } from '../Entities/Clusters/clusters.actions';
import {
  doClusterSearch,
  getClusterList,
  hideClusterListLoading,
  paginateClusterList,
  showClusterListLoading,
  updateClusterList,
} from './clusterlist.actions';
import { clusterListCallOptions } from '../../services/clusterlist.services';
import { updateStories } from '../Entities/Stories/stories.actions';

const normalizeStory = (entity: any) => {
  return {
    id: entity.id,
    name: entity.name,
    type: entity.type,
    initial_app_id: entity.initial_app_id,
    resource_id: entity.resource_id,
    content_type: entity.content_type,
    headline: entity.headline,
    subline: entity.subline,
  };
};

export const storySchema = new schema.Entity('story', undefined, {
  processStrategy: normalizeStory,
  idAttribute: 'id',
});

const normalizeClusters = (entity: any) => ({
  id: entity.id,
  headline: entity.headline,
  name: entity.name,
  subline: entity.subline,
  text: entity.text,
  stories: entity.stories.data,
});

export const clusterSchema = new schema.Entity(
  'cluster',
  { stories: [storySchema] },
  { processStrategy: normalizeClusters, idAttribute: 'id' }
);

function* fetchClusterList(page?: number) {
  yield put(showClusterListLoading());
  const {
    clusterList: { searchQuery },
  } = yield select() as any;

  let params = {
    ...(searchQuery ? { 'filter[search]': searchQuery } : {}),
    ...(page ? { page: page } : {}),
    ...{ include: 'stories' },
  };

  const callOptions = clusterListCallOptions(params);
  const data = yield call(callApi, callOptions);
  if (data && data.ok) {
    const normalizedClusterList = normalize(data.data, {
      data: [clusterSchema],
    }) as any;

    yield put(
      updateClusterList({
        pagination: normalizedClusterList.result.meta.pagination,
        clusterIds: normalizedClusterList.result.data,
      })
    );
    yield put(updateClusters(normalizedClusterList.entities.cluster));
    yield put(updateStories(normalizedClusterList.entities.story));
  }
  yield put(hideClusterListLoading());
}

export function* watchForClusterListLoad() {
  while (true) {
    yield take(getClusterList.type);
    const {
      clusterList: { pagination },
    } = yield select() as any;

    yield fetchClusterList(pagination ? pagination.currentPage : 1);
  }
}

export function* watchForClusterSearch() {
  while (true) {
    yield take(doClusterSearch.type);

    const {
      clusterList: { pagination },
    } = yield select() as any;

    yield fetchClusterList(pagination ? pagination.currentPage : 1);
  }
}

export function* watchForClusterListPagination() {
  while (true) {
    const {
      payload: { page },
    } = yield take(paginateClusterList.type);

    yield fetchClusterList(page);
  }
}



// WEBPACK FOOTER //
// ./src/store/ClusterList/clusterlist.saga.ts